import { render, staticRenderFns } from "./ArticleInputPanel.vue?vue&type=template&id=f9c5b928&scoped=true"
import script from "./ArticleInputPanel.vue?vue&type=script&lang=js"
export * from "./ArticleInputPanel.vue?vue&type=script&lang=js"
import style0 from "./ArticleInputPanel.vue?vue&type=style&index=0&id=f9c5b928&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c5b928",
  null
  
)

export default component.exports